module.exports = __webpack_public_path__ + "img/PL08179.86dde087.png";